import { Model$ListingGroup } from './ApiType';

export const isEveryThingElseRow = (item: Model$ListingGroup) =>
  !!(item && item.Condition && !item.Condition.Attribute && item.Condition.Operand);
